// extracted by mini-css-extract-plugin
export default {"careerpage":"CareerPage_careerpage__BM2Wk"};